import { Injectable, inject } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { LoanOfficerModel } from '../../cmg-1003/models';
import { SessionStore } from '../../core/state';
import { iStoreActions } from '../core/store-actions.interface';

function createInitialState(): LoanOfficerModel {
  return <LoanOfficerModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-loan-officer-store' })
export class Cmg1003LoanOfficerStore extends Store<LoanOfficerModel> implements iStoreActions<LoanOfficerModel> {
  private readonly _sessionStore = inject(SessionStore);

  private _initValue: LoanOfficerModel = null;
  constructor() {
    super(createInitialState());
  }

  override akitaPreUpdate(_: Readonly<LoanOfficerModel>, nextState: Readonly<LoanOfficerModel>): LoanOfficerModel {
    this._sessionStore.update({ lastUpdatedDateTime: Date.now() });
    return nextState;
  }

  preInitialize(loanOfficer: LoanOfficerModel): void {
    this.update(loanOfficer);
    this._initValue = JSON.parse(JSON.stringify(this.getValue()));
  }

  get initialValue() {
    return this._initValue;
  }
}
